import React, { useState, useContext, createContext } from "react";

const challengeWidgetContext = createContext()

export function ProvideChallengeWidget({children}) {
    const widget = useProvideChallengeWidget()
    return <challengeWidgetContext.Provider value={widget}>{children}</challengeWidgetContext.Provider>;
}

export const useChallenge = () => {
    return useContext(challengeWidgetContext)
}

function useProvideChallengeWidget() {

    const [challenge, setOffering] = useState(null);
    const setChallengeOffering = (challenge) => {
        setOffering(challenge)
    }

    return {
        setChallengeOffering,
        challenge
    }
}